import { render, staticRenderFns } from "./OfertaCrud.vue?vue&type=template&id=fe450cd4&"
import script from "./OfertaCrud.vue?vue&type=script&lang=js&"
export * from "./OfertaCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports